import React from "react";
import { ShieldX } from "lucide-react";

const AccessDenied = () => (
  <div className="min-h-full flex items-center justify-center p-8">
    <div className="max-w-md text-center rounded-3xl bg-white border border-slate-200 shadow-sm p-10">
      <ShieldX className="mx-auto text-amber-500 mb-4" size={52} />
      <h1 className="text-2xl font-bold text-slate-900">Access denied</h1>
      <p className="mt-2 text-slate-500">
        Your assigned roles do not allow access to this page.
      </p>
    </div>
  </div>
);

export default AccessDenied;
